<template>
  <div class="pharma">
    <div class="content">
      <p class="explain"><b>数据库说明: </b>本数据库可以使用doi、pmid、标题查询全文, 对<span style="color: #A7231E">VIP4用户</span>开放使用, 单日限制1线程查看100次!</p>
      <p class="searching">
        <el-col :span="10" :offset="3">
          <el-input size="medium" v-model="input" placeholder="请输入 doi、pmid、标题 内容查询" @keyup.enter.native="search"></el-input>
        </el-col>
        <el-col :span="8" style="padding-left:15px">
          <el-button size="medium" @click="search">搜索</el-button>
          <el-button size="medium" @click="input=''">清空</el-button>
          <el-dropdown @visible-change="visible_change" @command="handleCommand">
            <span class="el-dropdown-link">
              今日查看历史<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="pull_down">
              <el-dropdown-item :command="item" v-for="(item, i) in history_data" :key="item+i">({{i+1}}) {{ item }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </p>
      <div class="result">检索结果: <span>{{tableData.length}}</span> 条</div>
      <div v-loading="vloing" style="min-height: 300px">
        <div class="queryitem" v-for="(item, index) in tableData" :key="item.title+index">
          <h3><label>标题: </label>{{ item.title }}</h3>
          <p><label>出版社: </label>{{ item.publisher }}<a :href="`/pdf/${item.dcode}`" v-if="item.dcode" class="full-text-btn" target="_blank">查看全文</a><a :href="item.seekhelpurl" v-else-if="item.seekhelpurl" class="full-text-btn full-text-btn-no" target="_blank">免费求助全文</a></p>
          <p><label>期刊: </label>{{ item.journal }}</p>
          <p><label>作者: </label>{{ item.author }}</p>
          <p><span v-if="item.doi" style="padding-right:20px"><label>doi: </label><a :href="`https://dx.doi.org/${item.doi}`" target="_blank" rel="noreferrer">{{ item.doi }}</a></span><span v-if="item.pmid"><label>pmid: </label><a :href="`https://pubmed.ncbi.nlm.nih.gov/${item.pmid}`" target="_blank" rel="noreferrer">{{ item.pmid }}</a></span></p>
          <p v-if="item.abstract"><label>摘要: </label><span v-html="item.abstract"></span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        props: {},
        input: "",
        now_node: null,
        tableData: [],
        vloing: false,
        total: 0,
        page_size: 15,
        page: 1,
        request_status: false,
        drawer: false,
        url: "",
        history_data: [],
        pdf_status: true,
        options: [],
        source: "",
        versions: ""
      };
    },
    created () {
      // if (localStorage.getItem("querytitlecontent")) {
      //   this.input = localStorage.getItem("querytitlecontent");
      // }
    },
    methods: {
      handleCommand(command) {
        var newLink = document.createElement('a');
        newLink.href = `/pdf/${command}`;
        newLink.target = '_blank';
        document.body.appendChild(newLink);
        newLink.click();
      },

      visible_change () {
        this.$http.postFullTextHistory({}).then(resp => {
          if (resp.code == 200) {
            this.history_data = resp.data
          }else{
            this.$message({
              message: response.msg,
              type: 'warning',
              customClass: 'hint-message',
              center: true
            });
          }
        }).catch(error=>{})
      },

      search () {
        if (!this.input.length) {
          return this.$message({
            message: '不能为空',
            type: 'warning',
            customClass: 'hint-message',
            center: true
          });
        }
        // localStorage.setItem("querytitlecontent", this.input)
        this.vloing = true;
        this.tableData = [];
        this.$http.postFullTextQuery({title: this.input}).then(resp => {
          if (resp.code == 200) {
            this.tableData = resp.data;
            if (!this.tableData.length) {
              this.$message({
                message: '未查询到数据',
                type: 'warning',
                customClass: 'hint-message',
                center: true
              });
            }
          }else{
            this.$message({
              message: resp.msg,
              type: 'warning',
              customClass: 'hint-message',
              center: true
            });
          }
          this.vloing = false;
        }).catch(error=>{
          this.vloing = false;
        })
      }
    }
  };
</script>

<style scoped>
.pharma {
  width: 1030px;
  margin: 0 auto;
}
.tree {
  padding: 10px;
}
.content {
  padding: 10px;
}
.explain {
  font-size: 14px;
  text-align: center;
}
.explain b{
  font-weight: 600;
}
.searching {
  padding: 30px 0;
  height: 30px;
}
.result {
  background-color:#eee;
  padding: 10px;
}
.result span {
  color: #A7231E;
  font-weight: 600;
}
.table >>> .el-button--mini {
  padding: 5px 2px;
}
.page {
  padding: 10px 0;
}
.read_pdf {
  width: 100%;
  height: 100%;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  margin-left: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.pull_down {
  max-height: 500px;
  width: 400px;
  overflow: auto;
}
table, td , th{
  border: 1px solid #777;
  padding: 2px 10px;
  font-size: 13px;
  text-align: center;
}
table {
  display: inline-block;
  padding: 0;
  border: none;
  margin-top: 10px;
  vertical-align: top;
}
.direction {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  vertical-align: top;
  margin-top: 10px;
  margin-right: 10px;
}
.red {
  color: #A7231E;
  padding: 5px 0;
  text-align: center;
  font-weight: 600;
}
.table >>> .el-table__row td, .table >>> .has-gutter th {
  padding: 0!important;
}
.pci_table {
  text-align: center;
  background-color: #efefef;
}
.result-dropdown {
  display: inline-block;
  position: relative;
  top: -6px;
  float: right;
}
.queryitem {
  padding: 0px 20px 15px;
  border-bottom: 1px solid #eee;
}
.full-text-btn {
  background: linear-gradient(135deg, #4D90FE 0%, #44b6f8 100%);
  padding: 2px 10px;
  font-size: 14px;
  color: #fff !important;
  border-radius: 3px;
  width: auto;
  display: inline-block !important;
  float: right;
  cursor: pointer;
  text-decoration: none;
}
.full-text-btn-no {
  background: linear-gradient(135deg, #f14c2f 0%, #e6ad33 100%) !important;
}
</style>